import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'

let config = {
    apiKey: 'AIzaSyD2uAzPvuYnrph_Xxbq4Xj6QV4v8OiL9Wk',
    authDomain: 'msorting-193e2.firebaseapp.com',
    projectId: 'msorting-193e2',
    storageBucket: 'msorting-193e2.appspot.com',
    databaseURL: 'https://msorting-193e2.firebaseio.com'
}

firebase.initializeApp(config)

export const GoogleProvider = new firebase.auth.GoogleAuthProvider()
export const auth = firebase.auth()
export const db = firebase.firestore()
export const st = firebase.storage()
export const fc = firebase.functions()
export default firebase